<template>
  <v-card>
    <div class="flex-grow-1 px-2">
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{title}}
          </div>
        </div>
        <div class="actions">
          <ButtonActionSave
            @click="downloadFile"
          />
        </div>
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            Št vrstic.
          </div>
          <div class="user-card-value">
            {{lines}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            MD5
          </div>
          <div class="user-card-value">
            {{md5}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            SHA1
          </div>
          <div class="user-card-value">
            {{sha1}}
          </div>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { saveAs } from 'file-saver'
import { base64StringToBlob } from 'blob-util'
import ButtonActionSave from './ButtonActionSave'

export default {
  components: {
    ButtonActionSave
  },
  props: {
    contents: {
      required: true,
      type: String
    },
    filename: {
      required: true,
      type: String
    },
    lines: {
      required: true,
      type: Number
    },
    md5: {
      required: true,
      type: String
    },
    sha1: {
      required: true,
      type: String
    }
  },
  computed: {
    title () {
      return this.filename.toUpperCase().replace('.TXT', '')
    }
  },
  methods: {
    downloadFile () {
      var blob = base64StringToBlob(this.contents)
      saveAs(blob, this.filename)
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
    &.not-active {
      background-color: #F5F5F5;
      border: 1px solid #EEEEEE;
    }
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      min-width: 30px;
      max-width: 30px;
      margin-left: 15px;
    }
  }
  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .user-card-label {
      min-width: 120px;
      color: #BDBDBD;
    }
    .user-card-value {
      color: #607D8B;
      font-weight: bold;
    }
  }
</style>
